import React from "react";

const ExamDetailsHeader = ({ data }) => {
  return (
    <div className="w-full flex-row align-center justify-start g-2 pb-2" style={{borderBottom:"2px solid var(--borderGray)"}}>
      <h3 className="t-18 poppins color-textColor weight-500">
        {data?.examName} (
        <span className="t-18 poppins color-greenColor">
          for {data?.gender?.toLowerCase()}
        </span>
        )
      </h3>

      <div className="flex-row align-center justify-start g-05">
        <span className="t-14 poppins-medium color-textGray">Duration:</span>
        <span className="t-14 poppins-medium color-greenColor">{data?.startDate}-{data?.endDate}</span>
      </div>
      <div className="flex-row align-center justify-start g-05">
        <span className="t-14 poppins-medium color-textGray">Venue:</span>
        <span className="t-14 poppins-medium color-greenColor">{data?.venue}</span>
      </div>
      <div className="flex-row align-center justify-start g-05">
        <span className="t-14 poppins-medium color-textGray">Conducted by:</span>
        <span className="t-14 poppins-medium color-greenColor">{data?.conductedBy}</span>
      </div>
    </div>
  );
};

export default ExamDetailsHeader;
